import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class StoredCreditService {
  baseHref = `${environment.apiUrl}/stored-credits`;

  constructor(private http: HttpClient) {}

  retrieveStoredCreditsBalance(): Observable<{ balance: number }> {
    // usedCode: string, offerId: string, userId: string
    const url = `${this.baseHref}/balance`;
    return this.http.get<any>(url);
  }

  getStoredCreditsOverview(): Observable<any> {
    const url = `${this.baseHref}/overview`;
    return this.http.get<any>(url);
  }

  requestStoredCreditsWithdrawal(): Observable<any> {
    const url = `${this.baseHref}/user-withdraw`;
    return this.http.get<any>(url);
  }
}
